import { observable, runInAction, action } from 'mobx'
import api from '../api'
import errorStore from './errorStore'
import translationStore from './translationStore'

class ConfirmLeadStore {
  @observable email = undefined
  @observable firstname = undefined
  @observable lastname = undefined
  @observable sentOnce = false
  @observable password = ''
  @observable passwordRepeat = ''
  @observable loaded = false
  @observable gtc = undefined
  @observable modalIsOpen = false
  @observable gtcText = ''
  @observable gtcTitle = ''

  constructor() {
    this.getGtc()
  }

  @action.bound setPassword(password) {
    this.password = password
  }

  @action.bound setSentOnce() {
    this.sentOnce = true
  }

  @action.bound setPasswordRepeat(passwordRepeat) {
    this.passwordRepeat = passwordRepeat
  }

  @action.bound toggleGtc() {
    console.log(this.gtc)
    this.gtc = !this.gtc
  }

  @action.bound setGtc(gtc) {
    this.gtc = gtc
  }

  @action.bound closeModal() {
    this.modalIsOpen = false
  }

  @action.bound showModal() {
    this.modalIsOpen = true
  }

  @action.bound async getGtc() {
    try {
      if(!this.gtcText) {
        const response = await api.Pages.byAlias('gtc')
        runInAction('get gtc', () => {
          this.gtcText = response.html
          this.gtcTitle = response.title
        })
      }
    } catch(error) {
      errorStore.displayError(translationStore.translate('retry_connection'))
    }
  }

  @action.bound async getLeadInformation(id) {
    try {
      if(this.loaded) {
        return
      }
      const request = await api.User.getLead(id)

      runInAction('get lead information', () => {
        this.email = request.email
        this.firstname = request.firstname
        this.lastname = request.lastname
        this.loaded = true
      })
    } catch (e) {
      errorStore.displayError(translationStore.translate('lead_error'))
    }
  }
}

export default new ConfirmLeadStore()



// WEBPACK FOOTER //
// ./src/stores/confirmLeadStore.js